import { createStore } from 'vuex'
import routes from "@/store/routes";
import authStore from "@/store/auth";
import clientsStore from "@/store/clients";
import productsStore from "@/store/products";
import emailSettingsStore from "@/store/emailSettings";
import tasksStore from "@/store/tasks";
import templatesStore from "@/store/templates"
import usersStore from "@/store/Users";
import productsPageStore from "@/store/productsPage";

import templatesPageStore from "@/store/templatesPage";

import emailSettingsPageStore from "@/store/emailSettingsPage";
import alertsStore from "@/store/alertsStore";
import rolesStore from "@/store/roles";


export default createStore({
  state: {
    // HERE BECAUSE GLOBAL "APP" VARIABLE
    spinnerIsShown: false,
  },
  actions: {
    showLoadingSpinner: ({ commit }) => {
      commit('SET_SPINNER', true)
    },
    hideLoadingSpinner: ({ commit }) => {
      commit('SET_SPINNER', false)
    }
  },
  mutations: {
    SET_SPINNER: (state, spinnerStatus) => {
      state.spinnerIsShown = spinnerStatus
    }
  },
  getters: {
    getSpinnerStatus: state => {
      return state.spinnerIsShown
    }
  },
  modules: {
    routes: routes,
    auth: authStore,
    clientsStore: clientsStore,
    productsStore: productsStore,
    emailSettingsStore: emailSettingsStore,
    tasksStore: tasksStore,
    templatesStore: templatesStore,
    userStore: usersStore,
    productsPageStore: productsPageStore,
    templatesPageStore: templatesPageStore,
    emailSettingsPageStore: emailSettingsPageStore,
    alertsStore: alertsStore,
    rolesStore: rolesStore
  }
})
